/* global React, Button, toast */
// Profile photo avatar and picker for Min side (account.jsx).
// Storage/Auth work lives in window.PlummeProfilePhoto (src/services/backend-profile-photo.jsx).

const PROFILE_PHOTO_ERROR_KEYS = {
  'profile-photo/type': 'acc.photoWrongType',
  'profile-photo/empty': 'acc.photoEmpty',
  'profile-photo/too-large': 'acc.photoTooLarge',
};

function profilePhotoErrorText(error, fallbackKey) {
  const key = PROFILE_PHOTO_ERROR_KEYS[error?.code];
  if (key) return t(key);
  return error?.message && !String(error.message).startsWith('profile-photo/') ? error.message : t(fallbackKey);
}

// Shows the photo when there is one, otherwise the initials. A photo that fails
// to load (deleted object, offline) falls back to the initials as well.
function ProfileAvatar({ photoURL, initials, className = 'emp-avatar' }) {
  const [failed, setFailed] = React.useState(false);
  React.useEffect(() => { setFailed(false); }, [photoURL]);
  if (photoURL && !failed) {
    return <span className={className} style={{ overflow: 'hidden', padding: 0 }}>
      <img src={photoURL} alt="" referrerPolicy="no-referrer" onError={() => setFailed(true)} style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
    </span>;
  }
  return <span className={className}>{initials}</span>;
}

function ProfilePhotoControls({ photoURL }) {
  const inputRef = React.useRef(null);
  const [busy, setBusy] = React.useState('');
  const service = window.PlummeProfilePhoto;
  const pick = () => {
    if (!service?.uploadProfilePhoto) { toast(t('acc.photoUnavailable'), 'error'); return; }
    inputRef.current?.click();
  };
  const onFile = async (event) => {
    const file = event.target.files?.[0];
    event.target.value = '';
    if (!file) return;
    setBusy('upload');
    try {
      await service.uploadProfilePhoto(file);
      toast(t('acc.photoSaved'), 'success');
    } catch (error) {
      toast(profilePhotoErrorText(error, 'acc.photoUploadFailed'), 'error');
    } finally {
      setBusy('');
    }
  };
  const remove = async () => {
    if (!service?.removeProfilePhoto) { toast(t('acc.photoUnavailable'), 'error'); return; }
    setBusy('remove');
    try {
      await service.removeProfilePhoto();
      toast(t('acc.photoRemoved'), 'success');
    } catch (error) {
      toast(profilePhotoErrorText(error, 'acc.photoRemoveFailed'), 'error');
    } finally {
      setBusy('');
    }
  };
  return <div className="row gap-10" style={{ flexWrap: 'wrap' }}>
    <input ref={inputRef} type="file" accept={service?.ACCEPT || 'image/png,image/jpeg,image/webp'} hidden onChange={onFile} />
    <Button variant="secondary" size="sm" icon="upload" disabled={Boolean(busy)} onClick={pick}>{busy === 'upload' ? t('acc.photoUploading') : t('acc.changePicture')}</Button>
    {photoURL && <Button variant="ghost" size="sm" icon="trash" disabled={Boolean(busy)} onClick={remove}>{busy === 'remove' ? t('acc.photoRemoving') : t('acc.removePicture')}</Button>}
  </div>;
}

Object.assign(window, { ProfileAvatar, ProfilePhotoControls });
